import React from 'react'
import styled, { css } from 'styled-components'
import { LinkThatLooksLikeTransparentButton } from '../_styled/Link'
import { TransparentButton } from '../_inputs/Button/Button'

export class ErrorBoundary extends React.Component {
  constructor (props) {
    super(props)
    this.state = {
      showMessage: props.showErrorMessage,
      hasError: false
    }
  }

  static getDerivedStateFromError (error) {
    // Update state so the next render will show the fallback UI.
    return { hasError: true }
  }

  async componentDidCatch (error, errorInfo) {
    const { sendToDatadog } = await import('~/hooks/useDatadog')
    sendToDatadog(`React error occurred: ${error.message}`,
      {
        errorInfo: errorInfo,
        errorData: error,
        url: window.location.href
      }
    )
  }

  renderFallback = () => {
    const clickHandler = () => {
      window.location.reload();
    };

    if (!this.state.showMessage) return null;

    return (
      <Container>
        <H1>Connection Error</H1>
        <SomethingWentWrongDiv styles={css`max-width: 428px`}>Something happened while loading this page. Please refresh the page.</SomethingWentWrongDiv>
        <RefreshBtn aria-label="Refresh Page" onClick={clickHandler}>Refresh Page</RefreshBtn>
        <SomethingWentWrongDiv styles={css`max-width: 475px`}>If this problem persists, please contact us for support.</SomethingWentWrongDiv>
        <ContactUsA
          title="Contact Us"
          href="/pages/contact-us"
        >Contact Us</ContactUsA>
      </Container>
    );
  };

  render() {
    return (
      <>
        {this.state.hasError
          ? this.renderFallback()
          : this.props.children
        }
      </>
    );
  }
}

const Container = styled.div`
  display: flex;
  flex-direction: column;
  justify-content: center;
  text-align: center;
  align-items: center;
  height: 30rem;
  width: 100%;
  margin-top: 6.4rem;
  padding-top: 10.4rem;
`

const H1 = styled.h1`
  display: flex;
  font-size: 3.6rem;
  margin-bottom: 1.6rem;
`

const SomethingWentWrongDiv = styled.div`
  display: flex;
  font-size: 2.4rem;
  ${props => props.styles};
`

const ContactUsA = styled(LinkThatLooksLikeTransparentButton)`
  border-radius: 0.8rem;
  height: 4.7rem;
  width: 24.9rem;
  padding: 0.8rem 1.6rem;
  font-size: 2.4rem;
  color: ${props => props.theme.textBlack};
  border: 1px solid #D9D9D9;
  margin: 1.6rem 0 3.2rem 0;
`

const RefreshBtn = styled(TransparentButton)`
  border-radius: 0.8rem;
  height: 4.7rem;
  width: 24.9rem;
  padding: 0.8rem 1.6rem;
  font-size: 2.4rem;
  color: ${props => props.theme.textBlack};
  border: 1px solid #D9D9D9;
  margin: 1.6rem 0 10.4rem 0;
`
